// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: dark;
  --bg: #0f1115;
  --panel: #171a21;
  --text: #f4f7fb;
  --muted: #a6b0c2;
  --accent: #c3a9e9;
  --danger: #fb7185;
  --border: rgba(255, 255, 255, 0.08);
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  min-height: 100%;
}

body {
  font-family:
    system-ui,
    -apple-system,
    'Segoe UI',
    Arial,
    Helvetica,
    sans-serif;
  background: var(--bg);
  color: var(--text);
  padding: 16px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  -webkit-text-size-adjust: 100%;
}

.app-root {
  width: min(100%, 980px);
  margin: 0 auto;
}

.app-title {
  font-size: clamp(24px, 4vw, 36px);
  margin: 0 0 8px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text);
}

p.lead {
  margin: 0 0 16px;
  color: var(--muted);
  line-height: 1.55;
  font-size: 15px;
}

.panel {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.viewer {
  position: relative;
  width: 100%;
  /** Etwas höher als zuvor (2:1) — mehr Bildfläche */
  aspect-ratio: 3 / 2;
  background: #000;
}

/* Video nicht display:none — iOS Safari braucht sichtbares Element im Layout */
.video-feed {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  pointer-events: none;
}

.overlay-canvas {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.scan-guide {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 86%;
  height: 40%;
  border: 2px solid var(--accent);
  border-radius: 14px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.12);
  pointer-events: none;
}

.viewer--paused .scan-guide {
  display: none;
}

.camera-paused-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(15, 17, 21, 0.78);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 16px;
  text-align: center;
}

.camera-resume-btn {
  padding: 14px 22px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 12px;
  min-height: 52px;
  min-width: 220px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

.camera-paused-hint {
  color: var(--muted);
  font-size: 13px;
  letter-spacing: 0.01em;
}

.status-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 14px;
  border-top: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.02);
}

.status-bar--bottom {
  margin-top: 16px;
  border-top: none;
  border: 1px solid var(--border);
  border-radius: 16px;
  background: var(--panel);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.status-bar--bottom .status-bar-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.status-bar-footer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.status-bar--bottom .status-bar-api-btn,
.status-bar--bottom .status-bar-camera-btn {
  flex-shrink: 0;
  padding: 6px 10px;
  min-height: 36px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 9px;
}

@media (max-width: 640px) {
  .status-bar--bottom {
    flex-direction: column;
    align-items: stretch;
  }

  .status-bar--bottom .status-bar-pills {
    width: 100%;
    flex: none;
    min-width: 0;
  }

  .status-bar-footer-actions {
    width: 100%;
    margin-left: 0;
    flex-shrink: 1;
    justify-content: flex-start;
  }
}

.pill {
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 13px;
  color: var(--muted);
  background: rgba(255, 255, 255, 0.03);
  line-height: 1.3;
}

.controls {
  display: flex;
  gap: 10px;
  padding: 16px;
  flex-wrap: wrap;
  align-items: center;
}

button {
  appearance: none;
  border: 0;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  min-height: 40px;
}

button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.primary {
  background: var(--accent);
  color: #07130b;
}

.secondary {
  background: #293041;
  color: var(--text);
}

.result {
  margin-top: 16px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 16px;
}

.result-barcode {
  font-size: clamp(17px, 3vw, 22px);
  font-weight: 700;
  margin: 0 0 10px;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: var(--text);
  word-break: break-word;
}

.result-title {
  font-size: clamp(22px, 4.2vw, 34px);
  font-weight: 800;
  margin: 0 0 12px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text);
  word-break: break-word;
}

.result-attr-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin: 0 0 10px;
}

.pill--shelf {
  background: #22c55e;
  color: #000;
  border-color: #16a34a;
  font-weight: 700;
  font-size: 14px;
  padding: 7px 12px;
}

.result-article-number {
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
  margin: 0 0 4px;
  word-break: break-word;
}

.result-main {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.result-main-text {
  flex: 1;
  min-width: 0;
}

.result-thumb-wrap {
  flex-shrink: 0;
}

.result-thumb {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.04);
  display: block;
}

.result-thumb--placeholder {
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
}

@media (max-width: 480px) {
  .result-thumb,
  .result-thumb--placeholder {
    width: 72px;
    height: 72px;
  }
}

.result-footer {
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.result .meta {
  margin-top: 6px;
  color: var(--muted);
  font-size: 14px;
  min-height: 20px;
  line-height: 1.45;
}

.result .meta--footer {
  font-size: 12px;
  color: var(--muted);
  opacity: 0.8;
  margin-top: 4px;
  min-height: 0;
}

.error {
  color: var(--danger);
  white-space: pre-wrap;
}

.login-panel {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 16px;
  max-width: 420px;
}

.login-panel label {
  display: block;
  font-size: 13px;
  color: var(--muted);
  margin-bottom: 6px;
}

.login-panel input {
  width: 100%;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--text);
  padding: 12px 12px;
  font-size: 16px;
  margin-bottom: 12px;
  min-height: 44px;
}

.app-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: nowrap;
  margin-bottom: 8px;
}

.app-header-main {
  flex: 1;
  min-width: 0;
}

.app-header-actions {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.btn-header-logout {
  padding: 6px 10px;
  min-height: 36px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  border-radius: 9px;
}

.muted {
  color: var(--muted);
}

.app-footer {
  margin-top: 20px;
  padding: 10px 4px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--border);
}

.app-footer-version {
  color: var(--muted);
  font-size: 12px;
  letter-spacing: 0.04em;
  opacity: 0.75;
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/assets/global.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;;;;;;cAMY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;EACzC,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;IACd,2BAA2B;EAC7B;AACF;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;iFAC+E;AACjF;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,kCAAkC;AACpC","sourcesContent":[":root {\n  color-scheme: dark;\n  --bg: #0f1115;\n  --panel: #171a21;\n  --text: #f4f7fb;\n  --muted: #a6b0c2;\n  --accent: #c3a9e9;\n  --danger: #fb7185;\n  --border: rgba(255, 255, 255, 0.08);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  min-height: 100%;\n}\n\nbody {\n  font-family:\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    Arial,\n    Helvetica,\n    sans-serif;\n  background: var(--bg);\n  color: var(--text);\n  padding: 16px;\n  padding-bottom: max(16px, env(safe-area-inset-bottom));\n  -webkit-text-size-adjust: 100%;\n}\n\n.app-root {\n  width: min(100%, 980px);\n  margin: 0 auto;\n}\n\n.app-title {\n  font-size: clamp(24px, 4vw, 36px);\n  margin: 0 0 8px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--text);\n}\n\np.lead {\n  margin: 0 0 16px;\n  color: var(--muted);\n  line-height: 1.55;\n  font-size: 15px;\n}\n\n.panel {\n  background: var(--panel);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n}\n\n.viewer {\n  position: relative;\n  width: 100%;\n  /** Etwas höher als zuvor (2:1) — mehr Bildfläche */\n  aspect-ratio: 3 / 2;\n  background: #000;\n}\n\n/* Video nicht display:none — iOS Safari braucht sichtbares Element im Layout */\n.video-feed {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.overlay-canvas {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.scan-guide {\n  position: absolute;\n  z-index: 2;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 86%;\n  height: 40%;\n  border: 2px solid var(--accent);\n  border-radius: 14px;\n  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.12);\n  pointer-events: none;\n}\n\n.viewer--paused .scan-guide {\n  display: none;\n}\n\n.camera-paused-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: rgba(15, 17, 21, 0.78);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  padding: 16px;\n  text-align: center;\n}\n\n.camera-resume-btn {\n  padding: 14px 22px;\n  font-size: 16px;\n  font-weight: 700;\n  border-radius: 12px;\n  min-height: 52px;\n  min-width: 220px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\n}\n\n.camera-paused-hint {\n  color: var(--muted);\n  font-size: 13px;\n  letter-spacing: 0.01em;\n}\n\n.status-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 14px;\n  border-top: 1px solid var(--border);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.status-bar--bottom {\n  margin-top: 16px;\n  border-top: none;\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  background: var(--panel);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.status-bar--bottom .status-bar-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.status-bar-footer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.status-bar--bottom .status-bar-api-btn,\n.status-bar--bottom .status-bar-camera-btn {\n  flex-shrink: 0;\n  padding: 6px 10px;\n  min-height: 36px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 9px;\n}\n\n@media (max-width: 640px) {\n  .status-bar--bottom {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .status-bar--bottom .status-bar-pills {\n    width: 100%;\n    flex: none;\n    min-width: 0;\n  }\n\n  .status-bar-footer-actions {\n    width: 100%;\n    margin-left: 0;\n    flex-shrink: 1;\n    justify-content: flex-start;\n  }\n}\n\n.pill {\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  padding: 6px 10px;\n  font-size: 13px;\n  color: var(--muted);\n  background: rgba(255, 255, 255, 0.03);\n  line-height: 1.3;\n}\n\n.controls {\n  display: flex;\n  gap: 10px;\n  padding: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\nbutton {\n  appearance: none;\n  border: 0;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  min-height: 40px;\n}\n\nbutton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.primary {\n  background: var(--accent);\n  color: #07130b;\n}\n\n.secondary {\n  background: #293041;\n  color: var(--text);\n}\n\n.result {\n  margin-top: 16px;\n  background: var(--panel);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 16px;\n}\n\n.result-barcode {\n  font-size: clamp(17px, 3vw, 22px);\n  font-weight: 700;\n  margin: 0 0 10px;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n  color: var(--text);\n  word-break: break-word;\n}\n\n.result-title {\n  font-size: clamp(22px, 4.2vw, 34px);\n  font-weight: 800;\n  margin: 0 0 12px;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: var(--text);\n  word-break: break-word;\n}\n\n.result-attr-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin: 0 0 10px;\n}\n\n.pill--shelf {\n  background: #22c55e;\n  color: #000;\n  border-color: #16a34a;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 7px 12px;\n}\n\n.result-article-number {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text);\n  margin: 0 0 4px;\n  word-break: break-word;\n}\n\n.result-main {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n}\n\n.result-main-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.result-thumb-wrap {\n  flex-shrink: 0;\n}\n\n.result-thumb {\n  width: 96px;\n  height: 96px;\n  object-fit: cover;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: rgba(255, 255, 255, 0.04);\n  display: block;\n}\n\n.result-thumb--placeholder {\n  background:\n    linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\n}\n\n@media (max-width: 480px) {\n  .result-thumb,\n  .result-thumb--placeholder {\n    width: 72px;\n    height: 72px;\n  }\n}\n\n.result-footer {\n  margin-top: 14px;\n  padding-top: 10px;\n  border-top: 1px solid var(--border);\n}\n\n.result .meta {\n  margin-top: 6px;\n  color: var(--muted);\n  font-size: 14px;\n  min-height: 20px;\n  line-height: 1.45;\n}\n\n.result .meta--footer {\n  font-size: 12px;\n  color: var(--muted);\n  opacity: 0.8;\n  margin-top: 4px;\n  min-height: 0;\n}\n\n.error {\n  color: var(--danger);\n  white-space: pre-wrap;\n}\n\n.login-panel {\n  background: var(--panel);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 16px;\n  max-width: 420px;\n}\n\n.login-panel label {\n  display: block;\n  font-size: 13px;\n  color: var(--muted);\n  margin-bottom: 6px;\n}\n\n.login-panel input {\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text);\n  padding: 12px 12px;\n  font-size: 16px;\n  margin-bottom: 12px;\n  min-height: 44px;\n}\n\n.app-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  flex-wrap: nowrap;\n  margin-bottom: 8px;\n}\n\n.app-header-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.app-header-actions {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-start;\n  padding-top: 2px;\n}\n\n.btn-header-logout {\n  padding: 6px 10px;\n  min-height: 36px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  border-radius: 9px;\n}\n\n.muted {\n  color: var(--muted);\n}\n\n.app-footer {\n  margin-top: 20px;\n  padding: 10px 4px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top: 1px solid var(--border);\n}\n\n.app-footer-version {\n  color: var(--muted);\n  font-size: 12px;\n  letter-spacing: 0.04em;\n  opacity: 0.75;\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
